import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { dashboardFeatureKey, reducer } from './dashboard.reducer';
import { DashboardEffects } from './effects/dashboard.effects';
import { EnvironmentProviders } from '@angular/core';

export const provideDashboardStore = (): EnvironmentProviders[] => [
    provideState(dashboardFeatureKey, reducer),
    provideEffects([DashboardEffects])
];
